import { Fragment } from 'react';
import { Link } from 'react-router';

import { renderContentMap } from 'my-core/online-course-content-map';

import LatexString from 'my-elements/LatexString';

import List from '@mui/material/List';
import ListItemButton, { listItemButtonClasses } from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

function InCourseExperienceChapterCover({ activeComponent, basePath }) {
  const chapter = activeComponent.data;

  return (
    <div css={({ breakpoints, spacing }) => ({ overflow: 'auto', [breakpoints.up('sm')]: { padding: spacing(1) } })}>
      <div
        css={({ breakpoints, palette, shape }) => ({
          backgroundColor: palette.background.paper,
          [breakpoints.up('sm')]: {
            maxWidth: 600,
            margin: 'auto',
            border: `1px solid ${palette.divider}`,
            borderRadius: shape.borderRadius,
          },
        })}
      >
        <div
          css={({ breakpoints, spacing }) => ({
            padding: spacing(2),
            [breakpoints.up('sm')]: { padding: spacing(4, 4, 2) },
          })}
        >
          <Typography sx={{ color: 'text.secondary' }} variant="overline">
            Chapter {activeComponent.pos}
          </Typography>
          <Typography variant="h4">
            <LatexString>{chapter.title}</LatexString>
          </Typography>
        </div>
        {renderContentMap(activeComponent, (component, renderChildren) => {
          switch (component.type) {
            case 'chapter':
              return renderChildren();
            case 'group':
              return (
                <Fragment key={component.key}>
                  {component.data.title && <Typography variant="h6">{component.data.title}</Typography>}
                  <List
                    sx={{ [`& > .${listItemButtonClasses.root}`]: { px: { xs: 2, sm: 4 }, py: { xs: 0.5, sm: 1 } } }}
                  >
                    {renderChildren()}
                  </List>
                </Fragment>
              );
            case 'section':
              return (
                <ListItemButton
                  key={component.key}
                  component={Link}
                  nativeButton={false}
                  to={`${basePath}${component.fullPath}`}
                >
                  <Typography sx={{ color: 'text.secondary', flex: '0 0 50px' }} variant="h6">
                    {component.fullPos}
                  </Typography>
                  <ListItemText primary={<LatexString>{component.data.title}</LatexString>} />
                </ListItemButton>
              );
          }
          return null;
        })}
      </div>
    </div>
  );
}

export default InCourseExperienceChapterCover;
